// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3jkJ1","box":"WorkspacesBox_box__j_Bci","node":"WorkspacesBox_node__2tmCB"};